module.exports = __webpack_public_path__ + "img/《传输承载网格系统》物联网（智慧平安小区）平台V1.0.55ecab78.png";